import React from "react";
import "./styles/inte.css";

const Integration = () => {
  return (
    <section className="inte-section">
      <div className="inte-container">
        <div className="inte-image">
          <img src="images/inte.png" alt="" />
        </div>
        <div className="inte-content">
            <div className="inte-group">
            <p className="inte-title">integration</p>
          <h2 className="inte-heading">Plug. Play. Profit.</h2>
            </div>
            <p className="inte-para">
          Integrating Real Opinion takes just a few minutes. Sign up on our dashboard, verify your app, and start monetizing instantly.
          </p>
          <button
          onClick={() => {
            window.open("https://prorewards.gitbook.io/real-opinion")
          }}
          className="btn-primary inte-btn">Open</button>
        </div>
      </div>
    </section>
  );
};

export default Integration;
